import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
  ApiEnvelope,
  ClaimDetails,
} from "@/pages/app/provider/billings/billing-types";
import { getConfigObject, getXtenantId } from "../../../utils/utils";
import { ClaimControllerApi } from "../../../services";

/**
 *
 * @author Atish Bagate
 */
interface GetClaimByIdProps {
  claimUuid: string;
}

export function useGetClaimById({
  claimUuid,
}: GetClaimByIdProps): UseQueryResult<
  ApiEnvelope<ClaimDetails> | undefined,
  AxiosError
> {
  return useQuery({
    queryKey: ["Get-claim-by-id", claimUuid],
    enabled: !!claimUuid,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new ClaimControllerApi(getConfigObject())
        .getClaimById(claimUuid, getXtenantId())
        .then((it) => it?.data as ApiEnvelope<ClaimDetails>),
  });
}
